import Vue from 'vue'

Vue.component('select-input', {
  props: {
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    ariaLabel: {
      type: String,
      default: '',
    },
    ariaLabelledBy: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    modifier: {
      type: String,
      default: 'default',
    },
    initialValue: {
      type: [String, Boolean],
      default: false,
    },
    initialValueGetter: {
      type: [Function, Boolean, String],
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    nullOption: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: 'There was an error.',
    },
    required: Boolean,
    validateMethod: {
      type: [Function, Boolean],
      default: false,
    },
    srOnly: Boolean,
    disabled: Boolean,
  },
  data() {
    const data = {
      inputValue: '',
      inputOptions: [],
      isValid: true,
      isActive: false,
      isFocus: false,
      randomID: 'select-input-' + Math.floor(Math.random() * 1000),
    }

    if (this.options && this.options.bind !== 'undefined') {
      const options = (typeof this.options === 'function') ? this.options() : this.options
      data['inputOptions'] = options.map(opt => {
        if (typeof opt !== 'undefined' && typeof opt.value === 'undefined') {
          return {
            value: opt,
            label: opt
          }
        }
        return opt
      })
    }

    if (this.initialValue) {
      data.inputValue = this.initialValue
    } else if (
      this.initialValueGetter &&
      this.initialValueGetter.bind !== 'undefined'
    ) {
      data.inputValue = this.initialValueGetter(this.name)
    }

    return data
  },
  watch: {
    initialValue(value) {
      this.inputValue = value
    },
    inputValue(value) {
      this.$emit('change', {
        name: this.name,
        value,
      })

      if (this.inputValue) this.setActive()
      if (this.isFocus) this.isFocus = false
    },
    isValid(value) {
      if (!value) this.$refs.selectEl.focus()
    },
  },
  mounted() {
    this.$emit('change', {
      name: this.name,
      value: this.inputValue,
    })

    if (this.inputValue) this.setActive()

    document.addEventListener('keyup', (e) => {
      // When close select by using Escape on keyboard
      if (e.key === 'Escape') {
        if (this.isFocus) this.isFocus = false
      }
    })
  },
  methods: {
    validate() {
      if (this.validateMethod) {
        this.isValid = this.validateMethod({
          name: this.name,
          value: this.inputValue,
        })
      } else if (
        this.required &&
        (!('' + this.inputValue) || !this.inputValue)
      ) {
        this.isValid = false
      } else {
        this.isValid = true
      }
      return this.isValid
    },
    setActive() {
      this.isActive = true
    },
    unsetActive() {
      if (!this.inputValue) this.isActive = false
      if (this.isFocus) this.isFocus = false
    },
  },
  template: `
  <div
    class="select-input"
    :class="[
      'select-input--' + modifier,
      { 'is-active': isActive },
      { 'is-focus': isFocus },
      { 'has-error': !isValid },
      { 'is-required': required },
      { 'is-disabled': disabled },
    ]"
  >
    <label
      v-if="label"
      :id="'label-' + randomID"
      :for="randomID"
      class="select-input__label label"
      :class="{ 'sr-only': srOnly }"
    >
      {{ label || placeholder }}
    </label>
    <div class="select-input__wrapper">
      <select
        :id="randomID"
        ref="selectEl"
        v-model="inputValue"
        class="select-input__el p1"
        :name="name"
        :aria-label="ariaLabel"
        :aria-labelledby="ariaLabelledBy"
        :aria-describedby="!isValid ? 'error-' + randomID : null"
        :aria-required="required"
        :disabled="disabled"
        @input="$emit('input', $event.target.value)"
        @focus="isFocus = true"
        @blur="unsetActive"
        @click="isFocus = true"
      >
        <option v-if="nullOption" value="" disabled selected hidden>
          {{ nullOption }}
        </option>

        <template v-if="inputOptions.length">
          <option
            v-for="option in inputOptions"
            :key="option.value"
            :value="option.value"
            :selected="inputValue === option.value"
          >
            {{ option.label }}
          </option>
        </template>
      </select>
      <i class="select-input__icon icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xml:space="preserve"
          viewBox="0 0 11 6"
        >
          <path fill="#0F3DFB" d="M5.4 5.7.7 1.4l.6-.8 4.1 3.7L9.7.6l.6.8z" />
        </svg>
      </i>
    </div>

    <transition name="fade">
      <p v-if="!isValid" :id="'error-' + randomID" class="select-input__error">
        {{ error }}
      </p>
    </transition>
  </div>
  `,
})
